import type {
  GetProductPropertyArgs,
  GetProductPropertyResponse,
} from '@getaccept/lib-shared/src/product-library/product-properties/types/product-property';
import { apolloClientInternal } from '@getaccept/lib-shared/src/internal/apollo-client-internal';
import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { load } from '../graphql/product-property.queries';

export class ProductPropertiesService {
  static async load(args?: GetProductPropertyArgs): Promise<GetProductPropertyResponse> {
    const {
      data: {
        getProductProperties: { totalCount, productProperties },
      },
    } = await apolloClientInternal.query({
      query: load,
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
      variables: { ...args },
    });
    return { totalCount, productProperties };
  }
}
